import React from 'react'

// query
import { useQuery } from '@apollo/client'
import { GET_JOB_DAY_BY_ID_WITH_JOB_INFO } from '../../../../graphql/jobDay/jobDay.queries'

// components
import Card from '../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../components/cards/CardDataPoint/CardDataPoint.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons'

export default function JobDayJobInfo({ id }) {

    const { data } = useQuery(GET_JOB_DAY_BY_ID_WITH_JOB_INFO, {
        variables: { id }
    })

    let jobDay = {}
    let trucks = []

    if(data && data.jobDay) {
        jobDay = {...data.jobDay}
        if(jobDay.driver) {
            trucks.push(`#${jobDay.truck.number} - ${jobDay.driver.firstName} ${jobDay.driver.lastName}`)
        }
        if(jobDay.driver2) {
            trucks.push(`#${jobDay.truck2.number} - ${jobDay.driver2.firstName} ${jobDay.driver2.lastName}`)
        }
        if(jobDay.driver3) {
            trucks.push(`#${jobDay.truck3.number} - ${jobDay.driver3.firstName} ${jobDay.driver3.lastName}`)
        }
    }

    return (<Card header={{ icon: <FontAwesomeIcon icon={faInfo} size='2x' color='#707070' />, title: 'Job'}}>
        <CardDataPoint label='Number' value={data ? jobDay.job.id : ''}/>
        <CardDataPoint label='Address' value={data ? [`${jobDay.job.street1} ${jobDay.job.street2}`, `${jobDay.job.city}${jobDay.job.state ? ',' : ''} ${jobDay.job.state} ${jobDay.job.zipcode}`] : ''}/>
        <CardDataPoint label='Scope of Work' value={data ? jobDay.scopeOfWork : ""} />
        <CardDataPoint label='Trucks' value={data ? trucks : ""} />
        <CardDataPoint label='Vehicle Option' value={data ? jobDay.vehicleOption : ""} />
    </Card>)
}